import React from 'react';
import { useNavigate } from 'react-router-dom';
import { rexTechTheme } from '../Theme';
import { 
  User,
  LogIn
} from 'lucide-react';

const PublicHeader = () => {
  const navigate = useNavigate();

  return (
    <header style={{
      backgroundColor: rexTechTheme.colors.neutral.white,
      color: rexTechTheme.colors.primary.dark,
      padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.lg}`,
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 2px 15px rgba(0, 0, 0, 0.08)',
      borderBottom: `1px solid ${rexTechTheme.colors.neutral.gray}`
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '70px' // Increased header height
      }}>
        {/* Left Side: RexTech Logo PNG from public folder */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          height: '100%'
        }}>
          <a 
            href="/"
            style={{
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <img 
              src="/logo.png" 
              alt="RexTech Logo"
              style={{
                height: '100px', // Increased from 45px to 60px
                width: 'auto',
                objectFit: 'contain',
                maxWidth: '200px' // Added max width
              }}
            />
          </a>
        </div>

        {/* Right Side: Login and Register Buttons */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: rexTechTheme.spacing.md,
          height: '100%'
        }}>
          <button
            onClick={() => navigate('/login')}
            style={{
              padding: `${rexTechTheme.spacing.sm} ${rexTechTheme.spacing.xl}`,
              backgroundColor: 'transparent',
              border: `2px solid ${rexTechTheme.colors.primary.main}`,
              color: rexTechTheme.colors.primary.main,
              borderRadius: rexTechTheme.borderRadius.medium,
              cursor: 'pointer',
              fontSize: rexTechTheme.typography.fontSize.regular,
              fontWeight: rexTechTheme.typography.fontWeight.semiBold,
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: rexTechTheme.spacing.sm,
              height: '48px', // Slightly larger button
              ':hover': {
                backgroundColor: `${rexTechTheme.colors.primary.main}10`,
                color: rexTechTheme.colors.primary.dark,
                borderColor: rexTechTheme.colors.primary.dark,
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(10, 92, 54, 0.15)'
              }
            }}
          >
            <LogIn size={20} />
            Login
          </button>
          
          <button
            onClick={() => navigate('/register')}
            style={{
              padding: `${rexTechTheme.spacing.sm} ${rexTechTheme.spacing.xl}`,
              background: `linear-gradient(135deg, ${rexTechTheme.colors.primary.main} 0%, ${rexTechTheme.colors.primary.light} 100%)`,
              border: 'none',
              color: rexTechTheme.colors.neutral.white,
              borderRadius: rexTechTheme.borderRadius.medium,
              cursor: 'pointer',
              fontSize: rexTechTheme.typography.fontSize.regular,
              fontWeight: rexTechTheme.typography.fontWeight.semiBold,
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: rexTechTheme.spacing.sm,
              height: '48px', // Slightly larger button
              boxShadow: '0 4px 15px rgba(30, 132, 73, 0.3)',
              ':hover': {
                background: `linear-gradient(135deg, ${rexTechTheme.colors.primary.dark} 0%, ${rexTechTheme.colors.primary.main} 100%)`,
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(30, 132, 73, 0.4)'
              }
            }}
          >
            <User size={20} />
            Join as Client
          </button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;